import React from 'react';
import { useDispatch } from 'react-redux';
import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';
import styled from 'styled-components';
import { logoutUser } from '../../../store/actions/login/loginActions';
import Paragraph from '../../Paragraph/Paragraph';
import themeColors from '../../../assets/styles/themeColors';
import { variables } from '../../../assets/styles/variables';
import { ReactComponent as InfoIcon } from '../../../assets/images/svg/info-green.svg';
import Button from '../../Button/Button';

const ContentContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
`;

const BoldText = styled.span`
  font-size: 16px;
  font-weight: 600;
  color: ${themeColors.colorInfoText};
`;

const LineAboveInfoBox = styled.hr`
  display: block;
  height: 1px;
  width: 55%;
  border: 0;
  border-top: 1px solid ${themeColors.colorInfoLine};
  margin: 24px 24px;
`;

const InfoBox = styled.div`
  display: flex;
  background-color: ${themeColors.colorInfoBoxBg};
  padding: 8px 8px;
  margin: 0 16px;
  align-items: center;
  border: ${themeColors.colorInfoBoxBorder} solid 1px;
  border-radius: ${variables.borderRadius.borderRadius};
`;

const ButtonContainer = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-around;
  width: 95%;
  margin: 16px 16px;
`;

const SecondaryUserTerms = ({ primaryUserFirstName, primaryUserLastName }) => {
  const { t } = useTranslation();
  const dispatch = useDispatch();
  return (
    <ContentContainer>
      <Paragraph
        bold
        color={themeColors.colorInfoTitle}
        fontSize={29}
        marginBottom={16}
      >
        {t('updatedTerms.secondary.title')}
      </Paragraph>
      <Paragraph color={themeColors.colorInfoText}>
        {t('updatedTerms.secondary.subtitle1')}
      </Paragraph>
      <Paragraph color={themeColors.colorInfoText} marginBottom={16}>
        <BoldText>
          {primaryUserFirstName} {primaryUserLastName},{' '}
        </BoldText>
        {t('updatedTerms.secondary.subtitle2')}
      </Paragraph>
      <Paragraph color={themeColors.colorInfoText}>
        {t('updatedTerms.secondary.subtitle3', {
          primaryUserFirstName,
        })}
      </Paragraph>
      <LineAboveInfoBox />
      <InfoBox>
        <InfoIcon width="16px" />
        <Paragraph color={themeColors.colorInfoBoxText} marginLeft={8}>
          {t('updatedTerms.secondary.infoBoxText')}
        </Paragraph>
      </InfoBox>
      <ButtonContainer>
        <Button
          variant="default"
          size="xl"
          textTransform="none"
          marginTop={16}
          marginBottom={16}
          marginRight={16}
          marginLeft={16}
          isWidthS
          onClick={() => {
            dispatch(logoutUser());
          }}
        >
          {t('updatedTerms.secondary.buttonText')}
        </Button>
      </ButtonContainer>
      <Paragraph color={themeColors.colorInfoText} marginBottom={16}>
        {t('updatedTerms.footer1')}
        <BoldText>{t('updatedTerms.footer2')}</BoldText>
        {t('updatedTerms.footer3')}
      </Paragraph>
    </ContentContainer>
  );
};

SecondaryUserTerms.propTypes = {
  primaryUserFirstName: PropTypes.string,
  primaryUserLastName: PropTypes.string,
};

export default SecondaryUserTerms;
